function CapitalizeFirstFilter() {
  'ngInject';
  return function (input) {
    if(input){
      return input.substring(0,1).toUpperCase()+input.substring(1);
    }
  };
}
export default {
  name: 'CapitalizeFirstFilter',
  fn: CapitalizeFirstFilter
};